import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import { ROOT_URL } from '../../../config/global.js';

import '../../../../styles/scss/style.css';
import Icon from '../../atoms/Icon';
import TextAnchorIcon from '../../molecules/TextAnchorIcon';
import Image from '../../atoms/Image';
import DropdownMenu from '../DropdownMenu';
import LoadingScreen from '../LoadingScreen/LoadingScreenContainer';
import logoImage from '../../../../images/logo_text_bubble_white.svg';

class NavigationDashboard extends Component {
	constructor(props) {
		super(props)
		this.baseRoute = '/bots';
		this.state = {
			isNavOpen: this.props.isNavOpen,
			dropDownActive: false,
			activeClass: 'navigationDashboard__menuItem--active',
			navs: [
				{ route: this.baseRoute, icon: 'fa-list', text: 'Bots' },
				{ route: `${this.baseRoute}/${props.match.params.id}/subjects`, icon: 'fa-comments', text: 'Subjects' },
				{ route: `${this.baseRoute}/${props.match.params.id}/facebook`, icon: 'fa-facebook-official', text: 'Facebook' }
			]
		};

		this.handleDropDown = this.handleDropDown.bind(this);
		this.handleLogout = this.handleLogout.bind(this);
		this.clickOutside = this.clickOutside.bind(this);
		this.clickHandler = this.clickHandler.bind(this);
	}
	componentWillMount() {
		if (this.props.loginStatus.data.length <= 0) {
			this.props.fetchLoginStatus();
		}
	}
	componentWillReceiveProps(nextProps) {
		this.setState({ isNavOpen: nextProps.isNavOpen });
	}
	handleLogout = (e) => {
		e.preventDefault();
		const logoutRequest = axios({
			method: 'get',
			url: `${ROOT_URL}/api/auth/logout`
		});

		// Updates the store with the new login status
		logoutRequest.then((logoutRes) => {
			this.props.setLoginStatus(logoutRes.data);
		}).catch((error) => {
			console.log(error);
		});
	};
	handleActive = route => (
		route !== this.baseRoute && new RegExp(route).test(this.props.match.url) ? this.state.activeClass : null
	);
	renderNavs = () => {
		let { navs, activeClass } = this.state;
		let setActive = false;
		if (!this.props.match.params.id) {
			navs = navs.filter(nav => nav.route === '/bots');
			setActive = true;
		}
		navs.push({ route: '/logout', icon: 'fa-cog', text: 'Logout' });
		return (
			navs.map(nav => {
				!this.props.match.params.id && nav.route === '/bots' ? setActive = true : setActive = false
				return (
					<li className={`navigationDashboard__menuItem ${setActive ? activeClass : this.handleActive(nav.route)}`} key={nav.route}>
						<TextAnchorIcon icon={nav.icon} textAnchor={nav.text} href={nav.route !== '/logout' ? nav.route : ''} onClick={nav.route === '/logout' ? this.handleLogout : false} />
					</li>
				)
			})
		);
	};
	handleDropDown(e) {
		e.preventDefault();
		this.setState({ dropDownActive: !this.state.dropDownActive });
	}
	clickOutside(e) {
		let targetClass = e.target.className;
		// ignore clicks on the component itself
		if (targetClass.includes('navigationDashboard__menu')) {
			return;
		}
		this.clickHandler(e);
	}
	clickHandler(e) {
		if (!this.state.isNavOpen) {
			document.addEventListener('click', this.clickOutside, false);
			this.props.navStatus(true);
		} else {
			document.removeEventListener('click', this.clickOutside, false);
			this.props.navStatus(false);
		}
	}
	renderHandler(data, pages) {
		if (data === undefined) { return false; }
		// Protects the component to be logged in to see it
		if (data.message === 'NOT logged in' || data.message === 'logged out') {
			// Adds it to the browser history
			this.props.history.push("/login");
			return (
				<Redirect to={{
					pathname: '/login',
					state: { from: this.props.location } // This is the store state
				}} />
			)
		}

		return (
			<header className="navigationDashboard">
				<div className="navigationDashboard__upper">
					<div className="navigationDashboard__containerUpper">
						<div className="navigationDashboard__logo">
							<a href="/"><Image alt="Frankie Logo" src={logoImage} /></a>
						</div>
						<div className="navigationDashboard__profile">
							<TextAnchorIcon classType="textAnchorIcon--white" icon="fa-user" textAnchor={data.name} onClick={(e) => this.handleDropDown(e)} />
							<DropdownMenu iconType="fa-cog" listItem="Testing" activeClass={this.state.dropDownActive} onClick={(e) => this.handleLogout(e)} />
						</div>
						<Icon classType={`navigation__hamburger icon fa-2x ${this.state.isNavOpen ? 'fa-close' : 'fa-bars'}`} onClick={this.clickHandler} />
					</div>
				</div>
				<div className="navigationDashboard__lower">
				<div className="navigationDashboard__lowerContainer">
					<div className={`navigationDashboard__menu ${this.state.isNavOpen ? 'navigationDashboard__menu--active' : ''}`}>
						<ul className="navigationDashboard__menuList">
							{this.renderNavs()}
						</ul>
					</div>
				</div>
				</div>
				<LoadingScreen />
			</header>
		)
	}
	render() {
		const { data } = this.props.loginStatus; // Reads the store

		return this.renderHandler(data);
	}
}

//Making sure that it has a text property when it's declared
NavigationDashboard.propTypes = {
	type: PropTypes.string,
	paragraphText1: PropTypes.string,
	TextHeadingTwoText: PropTypes.string,
	paragraphText2: PropTypes.string
}

export default withRouter(NavigationDashboard);


// WEBPACK FOOTER //
// ./src/redux/components/organisms/DashboardNavigation/DashboardNavigation.jsx